import React, { use, useState } from "react";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddLocationModal from "./modal/AddLocationModal";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import useBanner from "../../../hooks/useBanner";

function BannerLocationTable({
  onTrigger,
  page,
  setPage,
  limit,
  setLimit,
  locationDatas,
  totalPages,
}) {
  const [openAddlocation, setOpenAddLocation] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedDeleteRow, setSelectedDeleteRow] = useState(null);
  const { deleteLocation } = useBanner();
  const [loading, setLoading] = useState(false);

  const handleEdit = (row) => {
    setSelectedRow(row);
    setOpenAddLocation(true);
  };

  const handleDelete = (row) => {
    setSelectedDeleteRow(row);
    setOpenDelete(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    await deleteLocation(setLoading, selectedDeleteRow?._id);
    onTrigger();
    setLoading(false);
    setOpenDelete(false);
    setSelectedDeleteRow(null);
  };

  return (
    <>
      <div className="p-4">
        <div className="overflow-x-auto border rounded-lg">
          <table className="min-w-full border-collapse">
            <thead className="bg-gray-50 text-gray-700 text-sm font-semibold">
              <tr>
                <th className="py-3 px-4 text-left">Title</th>
                <th className="py-3 px-4 text-left">Product</th>
                <th className="py-3 px-4 text-left">Action</th>
              </tr>
            </thead>

            <tbody className="text-gray-800 text-sm">
              {locationDatas.map((row) => (
                <tr
                  key={row._id}
                  className="border-t hover:bg-gray-50 transition-colors"
                >
                  <td className="py-3 px-4">{row.location}</td>
                  <td className="py-3 px-4">{row.product}</td>
                  <td className="py-3 px-4 flex gap-3">
                    <button
                      onClick={() => handleDelete(row)}
                      className="text-gray-600 hover:text-red-600"
                    >
                      <DeleteIcon size={16} />
                    </button>
                    <button
                      onClick={() => handleEdit(row)}
                      className="text-gray-600 hover:text-blue-600"
                    >
                      <ModeEditIcon size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {openAddlocation && (
        <AddLocationModal
          locationData={selectedRow}
          setOpenAddLocation={setOpenAddLocation}
          onTrigger={onTrigger}
        />
      )}

      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete the location "
            {selectedDeleteRow?.location}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)} color="primary">
            Cancel
          </Button>
          <button
            disabled={loading}
            onClick={handleConfirmDelete}
            color="error"
            className="bg-red-600 text-white rounded-lg px-4 py-2 "
            autoFocus
          >
            {loading ? "Deleting" : "Delete"}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BannerLocationTable;
